'use client';

import { FC } from 'react';
import { Filter } from '@/types/product-filter';
import { getProductFilterSkeletonHeight } from '@/utils/get-product-filter-skeleton-height';
import { useProductFilterLazy } from './product-filter-lazy-provider';

type PlaceholderProps = {
  filter: Filter;
};

export const ProductFilterPlaceholder: FC<PlaceholderProps> = ({ filter }) => (
  <div
    className="bg-default-100 mb-6 hidden w-64 shrink-0 animate-pulse rounded-lg @lg:block"
    style={{ height: getProductFilterSkeletonHeight(filter) }}
    aria-hidden="true"
    data-testid="product-filter__placeholder"
  />
);

type Props = {
  filter: Filter;
};

/**
 * Renders a skeleton until the shared lazy ProductFilter chunk is loaded.
 * All sidebar filters mount together via ProductFilterLazyProvider.
 */
const ProductFilterDeferred: FC<Props> = ({ filter }) => {
  const { FilterComponent, isDeferReady } = useProductFilterLazy();

  if (!isDeferReady || !FilterComponent) {
    return <ProductFilterPlaceholder filter={filter} />;
  }

  return <FilterComponent filter={filter} />;
};

export default ProductFilterDeferred;
